import { emptyPrompt } from '../Prompt';
import { promptVars } from '../variables';
export const planStructurePrompt = emptyPrompt
    .model('us.anthropic.claude-3-5-sonnet-20240620-v1:0')
    .system(`You are a software architect assistant helping to generate a structure for a web application.
Your task is to create a detailed execution plan.

CONTEXT:
- We need to generate a DSL (Domain-Specific Language) structure for a web application
- The structure needs to be validated and normalized
- We're using a streaming approach for real-time updates
- The final output should be valid Contember DSL syntax

REQUIREMENTS:
1. Plan should include multiple steps with clear objectives
2. Each step should have validation criteria
3. Consider error handling and edge cases
4. Include any necessary preparation or cleanup steps

Generate a detailed plan for this structure generation process.

----------

# Application name
${promptVars.name}

# Application specification
Specification describe the series of steps or operations that can be performed within the application, encompassing user interactions and data manipulations.

${promptVars.specification}

----------

# Application schema
The schema defines the structure of data within the application, including entities, their attributes, and relationships between them.

${promptVars.model}

`)
    .temp(0.5)
    .human('Generate a plan for the structure generation process. You should define most useful user workflows and views for the application in order to help structure generator agent to create a structure.');
//# sourceMappingURL=planStructurePrompt.js.map